import React from 'react'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../Sliders/projectSlider.css";
import { FaGithub, FaExternalLinkAlt } from "react-icons/fa";
import sp from '../../assest/shortest-path.jpg';
import sas from '../../assest/spot-and-solve.jpg';
import ha from '../../assest/hostel-accommodation.jpg';
import hms from '../../assest/health-monitoring-system.jpg';
import bb from '../../assest/python-bus-booking.jpg';
import MTA from '../../assest/money-transfer-app.jpg';

export default function projectSliders() {

    const linkroster = [
        {
            id: 1,
            title: 'Offline Money Transfer System',
            description: "Developed an offline money transfer app to transfer money in both offline and online modes, based on a handshake protocol. When sending money offline, the token is stored locally and automatically synced to the server once the internet connection is restored.",
            Technology: "React Native, Node.js, Express.js, SQLite, PostgreSQL.",
            image: MTA,
            githubUrl: "",
            liveUrl: ""
        },
        {
            id: 2,
            title: 'Spot And Solve',
            description: 'Developed a road-based hazard reporting system with User, Admin, and Super Admin roles. Integrated automatic location detection of reported issues. Implemented a community voting system to prioritize high-impact road problems. Designed an admin workflow with deadlines and escalation to super admin for efficiency.',
            Technology: "React Native, Firebase.",
            image: sas,
            githubUrl: "",
            liveUrl: ""
        },
        {
            id: 3,
            title: 'Hostel Accommodation',
            description: "Developed a full-stack accommodation management system with an admin-focused dashboard. Implemented CRUD operations for tenant management and automated welcome emails. Designed a billing system for electricity (EB) and TV expenses. Integrated RethinkDB for real-time data storage and retrieval.",
            Technology: "React.js, Express.js, Node.js, RethinkDB.",
            image: ha,
            githubUrl: "",
            liveUrl: ""
        },
        {
            id: 4,
            title: 'Health Monitoring System',
            description: "Developed a Health Monitoring System with pill reminders and educational health videos. Enabled users to set alarms for medications and watch videos on common illnesses. Improved user engagement and health tracking efficiency with a feature-rich app.",
            Technology: "React Native, Firebase.",
            image: hms,
            githubUrl: "",
            liveUrl: ""
        },
        {
            id: 5,
            title: 'Shortest Path',
            description: 'This paper introduces a hybrid routing framework combining Dijkstra\u2019s and A* algorithms for efficient, real-world pathfinding using OpenStreetMap data. The system dynamically selects the optimal algorithm based on performance and travel time, ensuring reliability even if one method fails. It includes heuristic optimizations and real-time congestion-based visualizations.',
            Technology: "Python, Flask, TomTom API, HTML, CSS, JavaScript.",
            image: sp,
            githubUrl: "",
            liveUrl: ""
        },
        {
            id: 6,
            title: 'Bus Booking System',
            description: "Developed a Python-based bus ticket booking system using Tkinter for a user-friendly interface. Enabled users to select, book, and view tickets, similar to RedBus but without a payment option. Utilized SQLite for efficient data storage and retrieval, ensuring smooth booking management.",
            Technology: "Python, Tkinter, SQLite.",
            image: bb,
            githubUrl: "",
            liveUrl: ""
        },
    ]

    var settings = {
        dots: true,
        infinite: true,
        speed: 400,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    };

    return (
        <div className="slider-wrapper">
            <Slider {...settings}>
                {linkroster.map((item) => (
                    <div key={item.id}>
                        <div className="LR-card">
                            <img className="LR-image" src={item.image} alt={item.title} />
                            <div className="LR-title">{item.title}</div>
                            <div className="LR-description">{item.description}</div>
                            <div className="LR-tech-tags">
                                {item.Technology.split(',').map((t) => t.trim().replace(/\.$/, '')).filter(Boolean).map((tech) => (
                                    <span key={tech} className="LR-tech-tag">{tech}</span>
                                ))}
                            </div>
                            {(item.githubUrl || item.liveUrl) && (
                                <div className="LR-links">
                                    {item.githubUrl && (
                                        <a href={item.githubUrl} target="_blank" rel="noopener noreferrer" className="LR-link-btn">
                                            <FaGithub size={16} /> Code
                                        </a>
                                    )}
                                    {item.liveUrl && (
                                        <a href={item.liveUrl} target="_blank" rel="noopener noreferrer" className="LR-link-btn">
                                            <FaExternalLinkAlt size={14} /> Live Demo
                                        </a>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </Slider>
        </div>
    )
}
